import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import "./Contribution.css"
import Yellow_arrow_btn from '../../common_components/common_btn/yellow_arrow_btn/Yellow_arrow_btn'

const Contribution = () => {
    return (
        <section className='contribute_section section_margin '>
            <Container>
                <div className='section'>
                    <Row >
                        <Col xl={8} md={7} sm={8}>
                            <div className='text_section'>
                                <h2 className='title'>
                                    Every Contribution Matters
                                </h2>
                                <p className='description'>
                                    Dreams don’t grow alone they need support, passion,
                                    & belief,Join a global<br /> community of changemakers who back
                                    creative minds, entrepreneurs, and innovators.
                                </p>

                                <p className='highlight'>
                                    <span>Every small contribution helps bring big visions to life. </span>
                                </p>

                                <Yellow_arrow_btn btnText="Click to See Campaigns" />
                            </div>
                        </Col>

                        <Col xl={4} md={5} sm={4} className='hand_img_holder'>
                            <div className='image_section'>
                                <img src='./assets/images/home/contribution/contribution.png' alt='Contribution' className='contribute_img' />
                            </div>
                        </Col>
                    </Row>
                </div>
            </Container>
        </section>
    )
}

export default Contribution;